import { useNavigate, useSearchParams } from "react-router-dom";
import { IColaboradorAtualizarForm } from "../../../types/colaborador";
import { TipoColaboradorEnum } from "../../../enums/tipoColaborador";
import { useContextSite } from "../../../context/Context";
import { Colaborador } from "../../../services/Colaborador";
import { toast } from "react-toastify";
import { useUserPermissions } from "../../../hooks/useUserPermissions";
import { FormCollaboratorEditValues } from "../../Molecules/FormCollaboratorEdit/useFormCollaboratorEdit";

export const useCollaboratorDetail = () => {
  const [params] = useSearchParams();
  const id = params.get("id");
  const { setIsLoad } = useContextSite();
  const navigate = useNavigate();
  const { isAdmin, canResetPassword } = useUserPermissions();

  const shouldShowResetPasswordButton = isAdmin() || canResetPassword();

  function handleSubmit(data: FormCollaboratorEditValues) {
    setIsLoad(true);

    const PAYLOAD: IColaboradorAtualizarForm = {
      nome: data?.nome,
      perfis: data?.perfis?.map((e) => e.value),
      telefone: data?.telefone,
      tipo: data?.tipo as TipoColaboradorEnum,
      uuid: id,
      email: data?.email,
      uuidLojas: data?.uuidLojas?.map((e) => e.value),
      uuidDeliverys: data?.uuidDeliverys?.map((e) => e.value),
      ativo: data?.ativo,
    };

    Colaborador.atualizar(PAYLOAD)
      .then(() => {
        toast.success("Colaborador atualizado com sucesso");
        navigate("/configuracoes/colaboradores");
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          toast.error(message);
        }
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  function handleResetPassword() {
    setIsLoad(true);
    Colaborador.resetPassword({ uuid: id! })
      .then(() => {
        toast.success("Senha redefinida com sucesso");
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          toast.error(mensagem);
        }
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  return { handleSubmit, shouldShowResetPasswordButton, handleResetPassword };
};
